module.exports = __webpack_public_path__ + "img/money-bag.7a10d5da.png";